import { atom } from "jotai";

export const userIdAtom = atom('')
export const blogIdAtom = atom('634266085029507885')